import React from 'react';
import {
	TestPlacement,
	Placement,
} from '@post-office/placements--cc-ai/audio-button-spotlight/test';

import { expValEquals } from '@confluence/feature-experiments';

export const AudioButtonSpotlight = ({ localDev = false }: { localDev?: boolean }) => {
	if (!expValEquals('confluence_audio_v3_changeboarding', 'isEnabled', true)) {
		return <></>;
	}

	if (localDev) {
		return <TestPlacement />;
	}

	// Replace with the actual placement component, not the test placement
	return <Placement />;
};
